const setOneDayAgo = () => {
  const today = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);

  return Math.ceil(today / 1000);
};

export default setOneDayAgo;
